<template>
  <div class="">
    <div class="flex flex-col gap-1">
      <h2 class="text-xl font-semibold text-gray-800">System Level App Configuration</h2>
      <p class="text-sm text-gray-600">
        {{ activeTab === "appConfig" ? "List of Registered Apps used for Promotions" : "View and Manage App Reviews" }}
      </p>
    </div>

    <!-- tabs -->
    <div class="flex flex-wrap items-center justify-between gap-2 md:mb-0 mb-2">
      <div class="flex bg-gray-200 rounded-lg">
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            activeTab === 'appConfig' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="switchTab('appConfig')"
        >
          App Configuration
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            activeTab === 'appReviews' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="switchTab('appReviews')"
        >
          Reviews/Autoreply Config
        </button>
      </div>
    </div>

    <!-- Tab Content Section -->
    <div v-if="activeTab === 'appConfig'">
      <appConfig />
    </div>
    <div v-if="activeTab === 'appReviews'">
      <appReviews />
    </div>
  </div>
</template>

<script>
import appConfig from "./appScreens/appConfig.vue";
import AppReviews from "./appScreens/appReviews.vue";

export default {
  name: "appMainSwitch",
  components: {
    appConfig,
    appReviews: AppReviews,
  },
  data() {
    return {
      activeTab: "appConfig",
    };
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
    },
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style>
